/*
 *   Copyright (c) 2020 
 *   All rights reserved.
 */
// Global configuration that clf site requires
import "./styles/main.scss";
import "./js/home";
import "./js/menu";
import "./js/autoSwitchTabs";
import "./js/switchTabs";
import "./js/dropdown";
import DonateNow from "./js/dontateNow";
import ArticleStickySideBar from "./js/articleStickySideBar";
import PostGrid from "./js/clfPostsGrid";
import SimpleForm from "./js/simpleForm";
import FooterForm from "./js/footerForm";
import FormGetInvolved from "./js/formGetInvolved";
import OurPartnersForm from "./js/ourPartnersForm";
import SpotlightCards from "./js/spotlightCards";
import SimpleCollapse from "./js/simpleCollapse";
import ImageBorder from "./js/imageBorder";
import SwiperImage from "./js/swiperImage";
import CustomCollage from "./js/customCollage";
import SimpleSlider from "./js/simpleSlider";
import ExternalLinksForArticles from "./js/externalLinksForArticles";
import OrganizationsEG from "./js/organizationsEG";
import {CardsInvolved} from "./js/cards-involved";
import $ from "jquery";

$(function () {
    new DonateNow();
    new ArticleStickySideBar();
    new PostGrid();
    new SimpleForm();
    new FooterForm();
    new FormGetInvolved();
    new OurPartnersForm();
    new SpotlightCards();
    new SimpleCollapse();
    new ImageBorder();
    new SwiperImage();
    new CustomCollage();
    new SimpleSlider();
    new ExternalLinksForArticles();
    new OrganizationsEG();
    new CardsInvolved();
});
